import moment from 'moment-timezone/builds/moment-timezone-with-data';
export const buildDatesForUrl = (startDate, endDate) => {
    if(startDate && endDate) {
      return "?startDate=" + moment(startDate).format("YYYY-MM-DD") + "&endDate=" + moment(endDate).format("YYYY-MM-DD")
    }
  else {
    return ""
  }
}